export default "__VITE_ASSET__DCPKvYFv__"